<template>
    <div class="modules">
        <div class="payment-container">
            <div class="summary">
                <h1 class="title"> {{ $t("lang.feedback") }}</h1>
                <div class="tools">
                    <el-button size="small" @click="submiTittle">{{ $t("lang.feedback") }} <i class="el-icon-right"></i></el-button>
                </div>
            </div>
            <div class="box-wrapper">
                <div class="box-main">
                    <div class="step-container"> 
                        <div class="hd">
                            <div>
                                <div v-for="(item, index) in noticeLists" :key="index">
                                    <div class="tabList" @click="clickTitle(item)">
                                        <div class="lei">{{ $t("lang.feedbackType") }}:{{ item.feedbackTypeVal  }}</div>
                                        <div class="count">{{ item.title  }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="ipagination.pageNo"
                            :page-size="ipagination.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="ipagination.total">
                        </el-pagination>
                    </div>
                </div>
               
            </div>
        </div>
        <van-popup v-model="popupModel" round :close-on-click-overlay="false" @closed="closedTab" closeable :style="{ height: '45%',width:'55%' }">
            <div class="popup-mod">
                <div class="hd">
                    <h3 class="title"> {{ $t("lang.feedback") }}</h3>
                </div>
                <van-divider />
                <div class="selTab">
                    <span>{{ $t("lang.feedbackType") }} :</span> 
                    <el-radio-group v-model="feedbackType" @change="selectChanged" >
                        <el-radio :label="item.value" v-for="(item, index) in dateList" :key="index" >{{ item.title }}</el-radio>
                    </el-radio-group>
                </div>
                <div class="bd">
                     <div class="field">
                        <span>{{ $t("lang.FeedbackContent") }}</span> 
                        <DivEditable v-model="content" ref="feedback" @inputText="inputText" @input="inputTab" @inputFunc="inputFunc" @blurFunc="blurFunc" />
                        <!-- <van-field v-model="message" rows="5" autosize :label="$t('lang.feedback')"  type="textarea" maxlength="100" placeholder="请输入问题反馈" show-word-limit/> -->
                      </div>
                      <van-divider />
                </div>
                <div class="ft">
                    <div class="form-action">
                        <van-button    size="large" @click="subTittle" type="primary" >{{ $t("lang.submit") }}</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="tittleModel" round :close-on-click-overlay="false" @closed="closedTab" closeable :style="{ height: '70%',width:'70%' }">
            <div class="popup-mod">
                <div class="hd">
                    <h3 class="title"> {{ $t("lang.feedback") }}</h3>
                </div>
                <van-divider />
                <div v-for="(item, index) in tittleList" :key="index">
                    <div class="feiTab" v-if="item.role =='assistant'" >
                        <div >
                            <div class="feiTabList" >
                            <div class=" tie" v-html="item.content"></div>
                            <div class="time">{{ item.createTime }}</div>
                        </div>
                        </div>
                    </div>
                    <div class="tile" v-if="item.role =='user'">
                        <div>
                            <div class="tileList" >
                            <div class=" tie" v-html=" item.content"></div>
                            <div class="time">{{ item.createTime }}</div>
                        </div>
                        </div>
                    </div>
                </div>
                
                <div class="bdTab">
                      <div class="field">
                        <DivEditable v-model="content" ref="feedback"  @input="inputTab" @inputFunc="inputFunc" @blurFunc="blurFunc" />
                        <!-- <van-field v-model="message" rows="5" autosize :label="$t('lang.feedback')"  type="textarea" maxlength="100" placeholder="请输入问题反馈" show-word-limit/> -->
                      </div>
                      <van-divider />
                </div>
                <div class="ftTab">
                    <div class="form-action">
                        <van-button    size="large"  type="primary" @click="tittleTab" >{{ $t("lang.submit") }}</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
    </template>
    <script>
    import {BASE_GLOB_API, BASE_GLOB_DOMAIN} from "@/config.js";
    import {axiosGet, axiosPost} from '@/api/api';
    import { Toast } from 'vant';
    import DivEditable from '@/components/DivEditable'
    import EventBus from '@/utils/EventBus'
    export default {
        name:'feedback',
        components:{
            DivEditable,
        },
        data(){
            return {
                isShowAt: false, // 是否显示@弹窗
                form:{},
                domain:BASE_GLOB_API,
                url:{
                    save:BASE_GLOB_API+'/feedback/save',
                    page:BASE_GLOB_API+'/feedback/page',
                    getDictItems:BASE_GLOB_API+'/dict/getDictItems',
                    dialog:BASE_GLOB_API+'/feedback/dialog',
                },
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                popupModel:false,
                content:'',
                feedbackType:'',
                noticeLists:[],
                ipagination:{
                    pageNo:1,
                    pageSize:10,
                    total:0
                },
                dateList:[
                    {value: "1", title: this.$t("lang.SignUp")},
                    {value: "2", title: this.$t("lang.Sale")},
                    {value: "3", title: this.$t("lang.Game")},
                    {value: "4", title: this.$t("lang.bill")},
                    {value: "5", title: this.$t("lang.Deposits")}
                ],
                title:'',
                tittleModel:false,
                tittleList:[],
                askId:{},
                userList:[],
                assistantList:[]
            }
        },
        watch: {
            immediate: true,
            deep: true,
            inputContent(val) {
                console.log('父组件接收到的输入框的值', val);
                this.content = val
            }
        },
        created(){
            this.lang = sessionStorage.getItem("Language")
            this.lodList(1,10)
            EventBus.$on('share', value => {
      // 将 A 组件传递过来的数据保存到 B 组件
            console.log("value123",value)
           if(value){
              this.dateList =[
                    {value: "1", title: this.$t("lang.SignUp")},
                    {value: "2", title: this.$t("lang.Sale")},
                    {value: "3", title: this.$t("lang.Game")},
                    {value: "4", title: this.$t("lang.bill")},
                    {value: "5", title: this.$t("lang.Deposits")}
                ]
           
           }

        })
            // this.handleDictItems()
        },
        methods:{
            tittleTab(){
                if(!this.content){
                    this.$message.error('请输入反馈内容!');
                    return;
                }

                let params = {
                    content:this.content,
                    askId:this.askId.id,
                    feedbackState:this.askId.feedbackState,
                    feedbackType:this.askId.feedbackType,
                    title:this.askId.title,
                };
                axiosPost(this.url.save, params).then(res=>{
                    if(res.success){
                        this.content =''
                        this.clickTitle(this.askId)
                        this.$message.success(res.message);
                    }else{
                        this.clickTitle(this.askId)
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.clickTitle(this.askId)
                    this.$message.error(err);
                   
                })

            },
            clickTitle(e){
                this.askId = e
                let params = {
                    query:{
                        askId:e.id,
                    }
                };
                axiosPost(this.url.dialog, params).then(res=>{
                    if(res.success){
                        this.tittleList =[]
                        // this.tittleList =res.result.records
                        // this.userList =[]
                        // this.assistantList =[]
                         let List =res.result.records
                         List.forEach(item=>{
                            let user ={
                                account:item.account,
                                askId:item.askId,
                                content:item.content,
                                createTime:item.createTime,
                                feedbackState:item.feedbackState,
                                feedbackType:item.feedbackType,
                                headImg:item.headImg,
                                id:item.id,
                                nickname:item.nickname,
                                optUid:item.optUid,
                                optUname:item.optUname,
                                role:item.role,
                                title:item.title,
                                uid:item.uid,
                                updateTime:item.updateTime,
                                }
                                this.tittleList.unshift(user)
                            
                            });
                            this.tittleModel =true
                    }else{
                       
                        this.$message.error(res.message);
                     
                    }
                })
            },
            handleDictItems(){
               
               let params = ''
               axiosGet(this.url.getDictItems+'/'+"FeedbackType",params).then(res=>{
                   if(res.code ==0){
                      this.dateList =res.result
                   }else{
                       this.$message.error(res.message);
                   }
               })
           },
            inputTab(val){
                console.log("val",val)
                this.content = val
            },
            inputText(val){
                console.log("title",val)
                this.title = val.substring(0, 50)
            },
            selectChanged(value) {
              this.feedbackType = value
            },
            closedTab(){
                this.content =''
                this.feedbackType =''
                this.title =''
                this.userList=[],
                this.assistantList=[]
            },
            subTittle(){
               
                if(!this.feedbackType){
                    this.$message.error('请选择问题类型!');
                    return;
                }
                if(!this.content){
                    this.$message.error('请输入反馈内容!');
                    return;
                }

                let params = {
                    content:this.content,
                    feedbackType:this.feedbackType,
                    title:this.title,
                };
                axiosPost(this.url.save, params).then(res=>{
                    if(res.success){
                        this.closedTab()
                        this.popupModel=false;
                        this.lodList(1,10)
                        this.$message.success(res.message);
                    }else{
                        this.closedTab()
                        this.$message.error(res.message);
                     
                    }
                }).catch((err)=>{
                    this.closedTab()
                    this.$message.error(err);
                   
                })

            },
             // 输入框输入时回调函数
            inputFunc(data, event) {
                console.log('inputFunc', data, event);
                if (event.data === '@') {
                this.isShowAt = true; // 显示弹窗
                this.$nextTick(() => {
                    let dom = document.getElementsByClassName('at-pop-index')[0]; // 获取成员列表弹窗，需要放在nextTick中
                    // 设置位置
                    dom.style.position = 'fixed';
                    dom.style.left = Math.floor(data.left + 10) + 'px';
                    dom.style.top = Math.floor(data.top) + 'px';
                    dom.style.zIndex = 9999;
                })
                } else {
                this.isShowAt = false;
                }
            },
            blurFunc(event) {
                // 失焦时延时关闭弹窗，避免还未拿到数据
                if (this.isShowAt) {
                setTimeout(() => {
                    this.isShowAt = false;
                }, 500);
                }
                console.log('blurFunc', event);
            },
            submiTittle(){
                this.popupModel=true;
            },
            lodList(pageNo,pageSize){
                let params = {
                    pageNo:pageNo,
                    pageSize:pageSize
                }
                axiosPost(this.url.page,params).then(res=>{
                    if(res.code ==200){
                    this.noticeLists =res.result.records
                    this.ipagination.pageNo = Number(res.result.current);
                    this.ipagination.pageSize =Number(res.result.size);
                    this.ipagination.total =Number(res.result.total);
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.lodList(val, this.ipagination.pageSize);
            },
        }
    }
    </script>
    <style lang="less" scoped>
    .payment-container {
        .summary {
            background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
        }
        .box-wrapper {
            display:flex; justify-content: space-between; align-items: flex-start;
            .box-main {
                flex:1;
                .step-container {
                  
                    .tabList{
                         height: 100px;
                         background-color: #FAFAFA;
                         margin: 20px 0;
                        .lei{
                            padding: 10px 40px;
                        }
                        .count{
                            padding: 10px 40px;
                        }
                    }
                }
                .pagination {
                    padding:15px 0; text-align:right;
                }
            }
           
           
        }
    }
    .popup-mod{
        height:max-content ;
        position: relative;
        .hd{
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            
        }
        .selTab{
            padding: 10px 10px;
            
        }
        .feiTab{
            padding: 10px 10px;
            
            .feiTabList{
                margin: 20px 0;
                border-radius: 20px;
                background-color: #f0f0f0;
                max-width: 80%;
                padding: 10px 40px;
                height: 40%;
                width: max-content;
                .time{
                    font-size: 10px;
                    padding: 10px 0 0 0;
                }
            }
        }
        .tile{
            padding: 10px 10px;
            &>div {
                display:flex; justify-content: flex-end; align-items: flex-start;
            }
            // float: right;
            .tileList{
                margin: 20px 0;
                border-radius: 20px;
                background-color: #529b2e;
                max-width: 60%;
                padding: 10px 40px;
                height: 40%;
                width: max-content;
                // .tie{
                //     word-wrap: break-word;
                //     width: max-content;
                // }
                .time{
                    font-size: 10px;
                    padding: 10px 0 0 0;
                }
            }
            
        }
        .bd{ 
            .field{
                padding: 0 10px;
            }
            .uploader{
                padding: 5px 0 0 15px;
            }
        }
        .ft{ 
           margin: 4px 0 0 0 ;
            .form-action{
                width: 200px;
                margin: 0 auto;
            }
        }
        .bdTab{
            margin: 120px 0 0 0;
            .field{
                padding: 0 20px;
            }
            .uploader{
                padding: 5px 0 0 15px;
            }
        }
        .ftTab{
            margin: 20px 0;
            .form-action{
                width: 200px;
                margin: 0 auto;
            }
        }
    }
   
    
    </style>